<!--US Page-->
<div class="dtf-accountdetails" *ngIf="!isCanadaPortal">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


  <!--Banner-->
  <section class="mbfs-home-hero"
    style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Finance_Lease_Header_image.jpg);">
    <section class="mbfs-home-hero__header">
      <h2 class="mbfs-home-hero__header-subtitle">
        {{ 'FinanceLeaseSolutions.Title' | translate }}
      </h2>
      <p class="mbfs-home-hero__header-text">
        {{ 'FinanceLeaseSolutions.TitleText' | translate }}
      </p>
    </section>
  </section>


  <section class='mbfs-repay-banner-inner'>
    <div class="mbfs-repay-banner-inner__box">
      <div class="mbfs-repay-banner-inner__box--text2">
        <h2 class="mbfs-repay-banner-inner__header-title">
          {{ 'FinanceLeaseSolutions.Subtitle' | translate }}
        </h2>
        <p class="mbfs-repay-banner-inner__header-text2">{{ 'FinanceLeaseSolutions.SubtitleText' | translate }}<span class="superscript">1, 2</span></p>
      </div>
    </div>
  </section>

  <!--Container: Key Product Features Table-->
  <div class="table-container">    
    <div class="table-title">
      <br>{{ 'FinanceLeaseSolutions.TableTitle' | translate }}<br><br>
    </div>   
      <div class="table">
        <div class="fill">
          <img src="static/assets/img/dtf-assets/images/redesign/DTF_FinanceProductChart-1.png" alt="" />
      </div>
      </div>
  </div>

  <!--Container: Photo Tiles and Icons-->
  <div class="container_dashboard" *ngIf="!isCanadaPortal">
    <!--49X-->
    <div class="row">
       <div class="col-sm-6">
          <div class="card1">
            <div class="card-body1" style="background: url(/static/assets/img/dtf-assets/images/redesign/Finance-Lease_Loans.png) no-repeat; background-size: 100% 100%;">
              <h4 class="dtfbrochures__title11">{{ 'FinanceLeaseSolutions.TileTitle' | translate }}</h4>
                <div class="row">
                   <h4 class="dtfbrochures__header31">Loans</h4>
                </div>
                <div>
                  <p class="dtfbrochures__paragraph11">{{ 'FinanceLeaseSolutions.Loans' | translate }}</p>
                </div>
                <br><br>
             </div>
          </div>
       </div>
       <!--FLTR-->
       <div class="col-sm-6">
          <div class="card1">
              <div class="card-body1" style="background: url(/static/assets/img/dtf-assets/images/redesign/Finance-Lease_TRAC.png) no-repeat; background-size: 100% 100%;">
              <h4 class="dtfbrochures__title11">{{ 'FinanceLeaseSolutions.TileTitle' | translate }}</h4>
                <div class="row">
                   <h4 class="dtfbrochures__header31">Terminal Rental Adjustment Clause (TRAC) Lease</h4>
                </div>
                <div>
                  <p class="dtfbrochures__paragraph11">{{ 'FinanceLeaseSolutions.TRAC' | translate }}</p>
                </div>
                <br><br>
             </div>
          </div>
       </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
         <div class="card1">
          <div class="card-body1" style="background: url(/static/assets/img/dtf-assets/images/redesign/Finance-Lease_ModTRAC.png) no-repeat; background-size: 100% 100%;">
              <h4 class="dtfbrochures__title11">{{ 'FinanceLeaseSolutions.TileTitle' | translate }}</h4>
               <div class="row">
                  <h4 class="dtfbrochures__header31">Modified TRAC Lease</h4>
                </div>
               <div>
                <p class="dtfbrochures__paragraph11">{{ 'FinanceLeaseSolutions.ModifiedTRAC' | translate }}</p>
               </div>
               <br><br>
            </div>
         </div>
      </div>
      <!--FLTR2-->
      <div class="col-sm-6">
         <div class="card1">
          <div class="card-body1" style="background: url(/static/assets/img/dtf-assets/images/redesign/Finance-Lease_ZeroTRAC.png) no-repeat; background-size: 100% 100%;">
            <h4 class="dtfbrochures__title11">{{ 'FinanceLeaseSolutions.TileTitle' | translate }}</h4>
            <div class="row">
                  <h4 class="dtfbrochures__header31">Zero TRAC Lease</h4>
               </div>
               <div>
                <p class="dtfbrochures__paragraph11">{{ 'FinanceLeaseSolutions.ZeroTRAC' | translate }}</p>
               </div>
               <br><br>
            </div>
         </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
         <div class="card1">
          <div class="card-body1" style="background: url(/static/assets/img/dtf-assets/images/redesign/Finance-Lease_FMV.png) no-repeat; background-size: 100% 100%;">
              <h4 class="dtfbrochures__title11">{{ 'FinanceLeaseSolutions.TileTitle' | translate }}</h4>
               <div class="row">
                  <h4 class="dtfbrochures__header31">FMV Lease</h4>
                </div>
               <div>
                <p class="dtfbrochures__paragraph11">{{ 'FinanceLeaseSolutions.FMV' | translate }}</p>
               </div>
               <br><br>
            </div>
         </div>
      </div>
      <!--FLTR3-->
      <div class="col-sm-6">
         <div class="card1">
          <div class="card-body1" style="background: url(/static/assets/img/dtf-assets/images/redesign/Finance-Lease_Dynamic.png) no-repeat; background-size: 100% 100%;">
            <h4 class="dtfbrochures__title11">{{ 'FinanceLeaseSolutions.TileTitle' | translate }}</h4>
            <div class="row">
                  <h4 class="dtfbrochures__header31">Dynamic Financing</h4>
               </div>
               <div>
                <p class="dtfbrochures__paragraph11">{{ 'FinanceLeaseSolutions.Dynamic' | translate }}</p>
                <a class="mbfs-button-1" href="{{this.usUrl}}/home/dynamicfinancing" target="_blank" style = "margin-right: 30%;">&#8250; {{ 'Programs.ProgramsButton1' | translate }}</a>
               </div>
               <br><br>
            </div>
         </div>
      </div>
    </div>
 </div>
  

  <!--Specialized Payment Options Icons-->
  <div class="card">
    <div class="mercedes-me-login__column">
      <h2 class="mercedes-me-login__column-headline">Specialized Payment Options</h2>
      <div class="payment-options-paragraph">{{ 'FinanceLeaseSolutions.PaymentOptions1' | translate }}<span class="superscript">1</span>{{ 'FinanceLeaseSolutions.PaymentOptions2' | translate }}</div>
      <br><br>
      <ul class="dtfbrochures__columns2">
        <li class="li1">
          <img src="static/assets/img/dtf-assets/images/redesign/Balloon-Payments-Icon.png">
          <h4 class="header1"> {{ 'FinanceLeaseSolutions.BalloonPaymentsTitle' | translate }}</h4>
          <p class="paragraph1"> {{ 'FinanceLeaseSolutions.BalloonPayments' | translate }}</p>
        </li>
        <li class="li1">
          <img src="static/assets/img/dtf-assets/images/redesign/Skip-Seasonal-Token-Payments-Icon.png">
          <h4 class="header1"> {{ 'FinanceLeaseSolutions.SkipPaymentsTitle' | translate }}</h4>
          <p class="paragraph1"> {{ 'FinanceLeaseSolutions.SkipPayments' | translate }}</p>
        </li>
        <li class="li1">
          <img src="static/assets/img/dtf-assets/images/redesign/Step-Payments.png">
          <h4 class="header1">{{ 'FinanceLeaseSolutions.StepTitle' | translate }}</h4>
          <p class="paragraph1">{{ 'FinanceLeaseSolutions.Step' | translate }}</p>
        </li>
      </ul>
    </div>
  </div>

  
<section class='mbfs-red-banner-inner'>
  <div class="mbfs-red-banner-inner__box">
    <div class="mbfs-red-banner-inner__box--text">
      <h2 class="mbfs-red-banner-inner__header-title">
        {{ 'FinanceLeaseSolutions.MoreInfo1' | translate}}
        <a href="{{this.targetRedirect}}brochures">click here</a>
        {{'FinanceLeaseSolutions.MoreInfo2' | translate}} <a href="{{this.targetRedirect}}dealerlocator"> {{
          'Header.FindADealer' | translate }}</a>
      </h2>
    </div>
  </div>
</section>

<!--Copyright footer-->
<footer id="mbfs-footer">
  <div role="contentinfo">
    <div class="mbfs-copyright">
      <sup>1 </sup><span class="paragraph1">{{ 'FinanceLeaseSolutions.Disclaimer1' | translate }} </span>
      <br>
      <sup>2 </sup><span class="paragraph1"> {{ 'FinanceLeaseSolutions.Disclaimer2' | translate }} </span>
      <br>
    </div>
  </div>
</footer>
</div>

<!--CA Page-->
<div class="dtf-accountdetails" *ngIf="isCanadaPortal">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


  <!--Banner-->
  <section class="mbfs-home-hero"
    style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Finance_Lease_Header_image.jpg);">
    <section class="mbfs-home-hero__header">
      <h2 class="mbfs-home-hero__header-subtitle">
        {{ 'FinanceLeaseSolutions.Title' | translate }}
      </h2>
      <p class="mbfs-home-hero__header-text">
        {{ 'FinanceLeaseSolutions.TitleText' | translate }}
      </p>
    </section>
  </section>

  <section class='mbfs-repay-banner-inner'>
    <div class="mbfs-repay-banner-inner__box">
      <div class="mbfs-repay-banner-inner__box--text2">
        <h2 class="mbfs-repay-banner-inner__header-title">
          {{ 'FinanceLeaseSolutions.Subtitle' | translate }}
        </h2>
        <p class="mbfs-repay-banner-inner__header-text2">{{ 'FinanceLeaseSolutions.SubtitleText' | translate }}<span class="superscript">1, 2, 4</span></p>
      </div>
    </div>
  </section>

  <!--Container: Key Product Features Table-->
  <div class="table-container">    
    <div class="table-title">
      <br>{{ 'FinanceLeaseSolutions.TableTitle' | translate }}<br><br>
    </div>   
      <div class="table">
        <div class="fill" *ngIf="!isFrench">
          <img src="static/assets/img/dtf-assets/images/redesign/DTF_CAEN_FinanceProductChart-1.png" alt="" />
        </div>
        <div class="fill" *ngIf="isFrench">
          <img src="static/assets/img/dtf-assets/images/redesign/DTF_CAFR_FinanceProductChart-1.png" alt="" />
        </div>
      </div>
  </div>

  <!--Container: Photo Tiles and Icons-->
  <div class="container_dashboard">
    <!--49X-->
    <div class="row">
       <div class="col-sm-6">
          <div class="card1">
            <div class="card-body1" style="background: url(/static/assets/img/dtf-assets/images/redesign/Finance-Lease_Loans.png) no-repeat; background-size: 100% 100%;">
              <h4 class="dtfbrochures__title11">{{ 'FinanceLeaseSolutions.TileTitle' | translate }}</h4>
                <div class="row">
                   <h4 class="dtfbrochures__header31">{{ 'FinanceLeaseSolutions.LoansHeader' | translate }}</h4>
                </div>
                <div>
                  <p class="dtfbrochures__paragraph11">{{ 'FinanceLeaseSolutions.Loans' | translate }}</p>
                </div>
                <br><br>
             </div>
          </div>
       </div>
       <!--FLTR-->
       <div class="col-sm-6">
          <div class="card1">
              <div class="card-body1" style="background: url(/static/assets/img/dtf-assets/images/redesign/Finance-Lease_TRAC.png) no-repeat; background-size: 100% 100%;">
              <h4 class="dtfbrochures__title11">{{ 'FinanceLeaseSolutions.TileTitle' | translate }}</h4>
                <div class="row">
                   <h4 class="dtfbrochures__header31">{{ 'FinanceLeaseSolutions.TRACHeader' | translate }}</h4>
                </div>
                <div>
                  <p class="dtfbrochures__paragraph11">{{ 'FinanceLeaseSolutions.TRAC' | translate }}<span class="superscript">1, 2</span></p>
                </div>
                <br><br>
             </div>
          </div>
       </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
         <div class="card1">
          <div class="card-body1" style="background: url(/static/assets/img/dtf-assets/images/redesign/Finance-Lease_ModTRAC.png) no-repeat; background-size: 100% 100%;">
              <h4 class="dtfbrochures__title11">{{ 'FinanceLeaseSolutions.TileTitle' | translate }}</h4>
               <div class="row">
                  <h4 class="dtfbrochures__header31">{{ 'FinanceLeaseSolutions.ModifiedTRACHeader' | translate }}</h4>
                </div>
               <div>
                <p class="dtfbrochures__paragraph11">{{ 'FinanceLeaseSolutions.ModifiedTRAC' | translate }}<span class="superscript">3, 4</span></p>
               </div>
               <br><br>
            </div>
         </div>
      </div>
    </div>
 </div>

  <!--Specialized Payment Options Icons-->
  <div class="mercedes-me-login__column">
    <h2 class="mercedes-me-login__column-headline">{{ 'FinanceLeaseSolutions.PaymentOptions1Header' | translate }}</h2>
    <div class="payment-options-paragraph">{{ 'FinanceLeaseSolutions.PaymentOptions1' | translate }}<span class="superscript">1,2</span></div>
    <br><br>
    <ul class="dtfbrochures__columns2">
      <li class="li1">
        <img style="width:auto" src="static/assets/img/dtf-assets/images/redesign/Balloon-Payments-Icon.png">
        <h4 class="header1"> {{ 'FinanceLeaseSolutions.BalloonPaymentsTitle' | translate }}</h4>
        <p class="paragraph1"> {{ 'FinanceLeaseSolutions.BalloonPayments' | translate }}</p>
      </li>
      <li class="li1">
        <img style="width:auto"src="static/assets/img/dtf-assets/images/redesign/Skip-Seasonal-Token-Payments-Icon.png">
        <h4 class="header1"> {{ 'FinanceLeaseSolutions.SkipPaymentsTitle' | translate }}</h4>
        <p class="paragraph1"> {{ 'FinanceLeaseSolutions.SkipPayments' | translate }}</p>
      </li>
      <li class="li1">
        <img style="width:auto" src="static/assets/img/dtf-assets/images/redesign/Step-Payments.png">
        <h4 class="header1">{{ 'FinanceLeaseSolutions.StepTitle' | translate }}</h4>
        <p class="paragraph1">{{ 'FinanceLeaseSolutions.Step' | translate }}</p>
      </li>
    </ul>
  </div>

  
<section class='mbfs-red-banner-inner'>
  <div class="mbfs-red-banner-inner__box">
    <div class="mbfs-red-banner-inner__box--text">
      <h2 class="mbfs-red-banner-inner__header-title">
        {{'Calculator.Information' | translate }} 
        <a href="{{this.targetRedirect}}brochures">{{'Calculator.ClickHere' | translate }} </a>
        {{'FinanceLeaseSolutions.MoreInfo2' | translate }} <a href="{{this.targetRedirect}}dealerlocator"> {{
          'Header.FindADealer' | translate }}</a>
      </h2>
    </div>
  </div>
</section>

<!--Copyright footer-->
<footer id="mbfs-footer">
  <div role="contentinfo">
    <div class="mbfs-copyright">
      <sup>1 </sup><span class="paragraph1">{{ 'FinanceLeaseSolutions.Disclaimer1' | translate }} </span>
      <br>
      <sup>2 </sup><span class="paragraph1"> {{ 'FinanceLeaseSolutions.Disclaimer2' | translate }} </span>
      <br>
      <sup>3 </sup><span class="paragraph1"> {{ 'FinanceLeaseSolutions.Disclaimer3' | translate }} </span>
      <br>
      <sup>4 </sup><span class="paragraph1"> {{ 'FinanceLeaseSolutions.Disclaimer4' | translate }} </span>
      <br>
    </div>
  </div>
</footer>
</div>


